import React, { FC } from "react";
import { Link } from "react-router-dom";
import halls from "../data/halls";

const HallsSection: FC = () => {
    return (
        <section className="halls" id="halls">
            <div className="halls__title">
                <h3>Наші зали</h3>
            </div>

            <div className="halls__grid">
                {halls.map((hall) => (
                    <div className="halls__grid-hall">
                        <div className="address">
                            <h3>{hall.title}</h3>
                            <p>{hall.address}</p>
                            <Link to={`/hall/${hall.id}`}>Дізнатися більше</Link>
                        </div>
                        <div className="info">
                            <img src={hall.image} alt="gym" />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HallsSection;
